module.exports = __webpack_public_path__ + "img/sunshine-page_460.5639aed3.png";